import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';
import { Col, Input, Row } from 'reactstrap';

import Button from '~components/Button';
import PopOver from '~components/pop-over/PopOver';

import { makeChange } from '~weekly-planner/reducers/unsaved';

import { selectAllChanges } from '~weekly-planner/selectors/unsaved';

import { Appointment } from '../../lib/common';

interface ComponentProps {
  isOpen?: boolean;
  target: string;
  toggle?: () => void;
  appointment: Appointment;
}

const AppointmentRosteringNotes: React.FC<ComponentProps> = ({ isOpen = false, target, toggle, appointment }) => {
  const dispatch = useAppDispatch();
  const changes = useAppSelector(selectAllChanges);

  const { id, parent_repeat_id, key, client, notes_admin: originalNotes } = appointment;
  const [note, setNote] = useState('');

  useEffect(() => {
    if (isOpen && key) {
      const changeNotes = changes[key]?.change.notes_admin;
      if (changeNotes) {
        const notesArr = changeNotes.split('<br>').filter(Boolean);
        return setNote(notesArr.length > 0 ? notesArr[notesArr.length - 1] : '');
      }
    }
    return setNote('');
  }, [isOpen, key, changes]);

  const onSubmit = () => {
    const newNotes = `${originalNotes || ''}${note}<br>`;
    dispatch(makeChange({ original: appointment, change: { id, parent_repeat_id, notes_admin: newNotes } }));
    toggle?.();
    setNote('');
  };

  return (
    <PopOver
      isOpen={isOpen}
      target={target}
      placement="right"
      autoFlip={true}
      className="popover show bs-popover-auto popover-inner appointment-popover"
      styleOverrides={{ padding: 0 }}
    >
      <div aria-label="Appointment Rostering Notes Popover" role="tooltip">
        <h3 className="popover-header" style={{ background: '#198754', color: '#fff' }}>
          Add Rostering Note
        </h3>
        <div className="pop-body popover-body">
          <Row className="title mb-2">{client?.full_name}</Row>
          <Row>
            <Col lg={12} className="mb-1">
              Add Rostering Note:
            </Col>
          </Row>
          <Row>
            <Col>
              <Input type="textarea" value={note} onChange={(e) => setNote(e.target.value)} style={{ minHeight: 60 }} />
            </Col>
          </Row>
          <div className="d-flex flex-column align-items-end">
            <Button className="mt-2" onClick={onSubmit}>
              Update
            </Button>
            <small className="text-danger">This will be saved on Weekly Planner Save *</small>
          </div>
        </div>
      </div>
    </PopOver>
  );
};

export default AppointmentRosteringNotes;
